<template>
  <!-- 日常培训 -->
  <div>
    <div class="main-panel">
      <div class="search-box gauge_20">
        <div class="input-item">
          <span class="label">姓名</span>
          <Input v-model="search.agentName" placeholder="请输入" />
        </div>
        <div class="input-item">
          <span class="label">工号</span>
          <Input v-model="search.workNo" placeholder="请输入" />
        </div>
        <div class="input-item">
          <span class="label">手机号</span>
          <Input v-model="search.mobile" placeholder="请输入" />
        </div>
        <div class="input-item">
          <span class="label">机构名称</span>
          <selectTree type="4" status="1" v-model="search.orgId"></selectTree>
        </div>
        <div class="input-item">
          <span class="label">培训时间</span>
          <DatePicker
            type="daterange"
            split-panels
            format="yyyy-MM-dd"
            separator="至"
            :transfer="true"
            placement="bottom"
            :value="search.date"
            @on-change="$set(search, 'date', $event)"
            placeholder="选择日期"
          ></DatePicker>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax(1)">查询</Button>
          <Button type="success" @click="exportToExcel" v-show="$units.pointAction('org_100_1')">导出</Button>
        </div>
      </div>
      <div class="table-box template-table">
        <loading :isShow="tableLoading" />
        <Table row-key="id" :columns="columns" :data="tableData" @on-selection-change="onSelectChange" border>
          <template slot-scope="{ row }" slot="fuzzMobile">
            <div style="display: flex; align-items: center; white-space: nowrap; justify-content: center">
              <span v-if="row.eyeShow">{{ row.mobile }}</span>
              <span v-else>{{ row.fuzzMobile }}</span>
              <div v-if="row.fuzzMobile">
                <i class="iconfont iconxianshi eye-icon eye" v-if="row.eyeShow" @click="openEye(row)"></i>
                <i class="iconfont iconyincang eye-icon eye" v-else @click="openEye(row)"></i>
              </div>
            </div>
          </template>

          <template slot-scope="{ row }" slot="courseNum">
            <span v-if="!row.courseNum">{{ row.courseNum }}</span>
            <a v-else class="course-num" @click="$refs.daliyDeatilRef.open(row.agentId)">{{ row.courseNum }}</a>
            /
            <span>{{ row.totalCourseNum }}</span>
          </template>

          <template slot-scope="{ row }" slot="trainNum">
            <span v-if="!row.trainNum">{{ row.trainNum }}</span>
            <a v-else class="course-num" @click="$refs.trainDetail.open(row)">{{ row.trainNum }}</a>
            /
            <span>{{ row.totalTrainCounts }}</span>
          </template>
        </Table>
        <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
      </div>
    </div>
    <!-- 学习课程数 -->
    <daliyDeatil ref="daliyDeatilRef"></daliyDeatil>

    <!-- 线下培训 -->
    <trainDetail ref="trainDetail" @suceess="searchAjax()"></trainDetail>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import daliyDeatil from './daliyDeatil';
import trainDetail from './trainDetail';
import selectTree from '@/components/system/selectTree3';
export default {
  mixins: [pageTool, common],
  components: {
    selectTree,
    daliyDeatil,
    trainDetail
  },
  props: {},
  data() {
    return {
      search: {
        // trainType: 1
      }, //查询数据
      tableLoading: false, //表格loading
      tabActive: '1',
      columns: [
        //表格字段
        {
          title: '机构名称',
          align: 'center',
          key: 'orgName',
          minWidth: 200
        },
        {
          title: '姓名',
          key: 'agentName',
          align: 'center'
        },
        {
          title: '工号',
          key: 'staffNo',
          align: 'center'
        },
        {
          title: '手机号',
          slot: 'fuzzMobile',
          align: 'center'
        },
        // {
        //   title: '线上已学课程数/总课程数',
        //   align: 'center',
        //   slot: 'courseNum'
        // },
        // {
        //   title: '线下签到培训数/总培训数',
        //   align: 'center',
        //   slot: 'trainNum'
        // },
        {
          title: '培训总时长',
          key: 'totalTime',
          align: 'center'
        }
      ],
      tableData: [], //表格数据
      total: 0, //表格记录数
      pageSize: 10, //页容量
      pageNum: 1 //当前页
    };
  },

  created() {
    this.searchAjax();
  },
  methods: {
    // 解密
    openEye(row) {
      if (!row.eyeShow) {
        this.descrypt(
          {
            query: row.id,
            operationFunction: 30,
            operationType: 2,
            otherInfo: {
              type: 1
            }
          },
          row,
          'mobile'
        ).then(() => {
          this.$set(row, 'eyeShow', true);
        });
      } else {
        this.$set(row, 'eyeShow', false);
      }
    },
    exportToExcel() {
      this.loading = true;
      const params = this.getParams();
      this.$http({
        url: '/buz/staffTrainRecord/read/list/export',
        type: 'POST',
        responseType: 'blob',
        data: params,
        apiPermissionCode: 'org_100_1'
      })
        .then(res => {
          this.loading = false;
          this.$units.daochu(res);
        })
        .catch(e => {
          this.loading = false;
        });
    },
    // 打开模板编辑或新增弹窗
    openTemplateEdit(item) {
      this.$refs.daliyDeatilRef.open(item.agentId);
    },
    onSelectChange() {},
    // 获取列表参数
    getParams() {
      const params = Object.assign({}, this.search);
      if (params.date && params.date[0]) {
        params.startTime = params.date[0] + ' 00:00:00';
        params.endTime = params.date[1] + ' 23:59:59';
      }
      delete params.date;
      return params;
    },
    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },
    // 获取列表数据
    getList() {
      const params = this.getParams();
      params.pageNo = this.pageNum;
      params.pageSize = this.pageSize;
      this.tableLoading = true;
      this.$http({
        url: '/buz/staffTrainRecord/read/list',
        type: 'post',
        data: params,
        apiPermissionCode: 'org_100_0'
      })
        .then(res => {
          this.tableLoading = false;
          this.tableData = res.data;
          this.total = res.total;
        })
        .catch(e => {
          this.tableLoading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.search-box {
  padding-right: 250px;

  .input-item {
    .label {
      font-size: 13px;
    }

    /deep/ .ivu-input {
      font-size: 13px;
    }

    /deep/ .ivu-select-selected-value {
      font-size: 13px;
    }
  }

  .btn-item {
    /deep/ .ivu-btn {
      font-size: 13px;
    }
  }
}

.course-num {
  color: #236dff;
}
</style>
